<template>
<div class="page_set page">
    <div class="tips phone">为了您的账号安全，请验证手机号。<br />当前手机号码：{{oldPhone}}</div>
    <div class="list erji">
        <div class="item">
            <div class="name">验证码：</div>
            <div class="code">
                <van-field v-model="code" placeholder="请填写手机验证码" />
            </div>
            <van-button class="action code" :loading="codeLoading" :disabled="codeBtnDisabled" @click="getCode">获取验证码</van-button>
            <!-- <div class="action" @click="getCode">获取验证码</div> -->
        </div>
    </div>
    <div class="big_btn btn" @click="tijiao">确认注销</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-zhuxiao",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, // 是否在iOSAndroid客户端内显示
            token: null,
            oldPhone: '',
            phone: '', // 手机号
            code: '', // 验证码
            codeLoading: false,
            codeBtnDisabled: false,
            delyTime: 5 // 获取验证间隔时间 s
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {

                })
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '永久注销账号',
                    // 'hiddenBack': true,
                    // 'rightStyle': 'setup'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
        },
        // 获取用户信息
        getData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    this.oldPhone = res.result.info.users.username
                }
            })
        },
        // 提交
        tijiao() {
            var params = {
                token: this.token,
                code: this.code
            }
            // if (!this.code) {
            //     this.$toast('请输入验证码');
            //     return
            // }
            var that = this
            this.$api.user.cancelUser(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
                    that.$toast('注销成功')
                    that.$store.commit(LOGOUT);
                    setTimeout(() => {
                        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                            var memberParams = {
                                'data': {
                                    forceLogin: 1
                                }
                            }
                            that.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                                
                            })
                            var styleParams = {
                                'data': {
                                    
                                }
                            }
                            that.$bridge.callhandler('sdjy://public/back', styleParams, (data) => {

                            })
                        } else {
                            that.$router.push("/");
                        }
                        
                    }, 2000);
                } else {
                    that.$toast(res.message)
                }
            })
        },
        // 获取验证码
        getCode() {
			var that = this
            if (!(/^1[3456789]\d{9}$/.test(that.phone))) {
                that.$toast('请输入合法的手机号');
                return
            } else if (that.phone == that.oldPhone) {
                that.$toast('不能与原手机号相同');
                return
            } else {
                that.codeBtnDisabled = true
                that.codeLoading = true
                var params = {
                    token: that.token,
                    phone: that.phone,
                    type: 1 // 0普通 1修改手机号 2小程序绑定手机号
                }
                that.$api.user.code(params).then(res => {
                    if (res.code == 200) {
						that.$toast('已发送');
						var s = setInterval(function () {
							var dely1 = parseInt(that.delyTime) - 1;
							that.delyTime = dely1
							console.log(dely1);
							if (dely1 == 0) {
								clearInterval(s);
								that.codeBtnDisabled = false
								that.codeLoading = false
								that.delyTime = 5;
							}
						}, 1000);
                    }else{
						that.$toast(res.message);
						that.codeLoading = false
						that.codeBtnDisabled = false
					}
                })
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
